import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=4d97442c&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=4d97442c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d97442c",
  null
  
)

export default component.exports